import React from 'react';
import { useTranslation } from 'react-i18next';

interface MachineInfoSectionProps {
  customerReference: string;
  softwareVersion: string;
  osVersion: string;
  workDescription: string;
  futureWorksDescription: string;
  followUpAfterService: string;
  onCustomerReferenceChange: (value: string) => void;
  onSoftwareVersionChange: (value: string) => void;
  onOsVersionChange: (value: string) => void;
  onWorkDescriptionChange: (value: string) => void;
  onFutureWorksDescriptionChange: (value: string) => void;
  onFollowUpAfterServiceChange: (value: string) => void;
  readOnly: boolean;
}

const MachineInfoSection: React.FC<MachineInfoSectionProps> = ({
  customerReference,
  softwareVersion,
  osVersion,
  workDescription,
  futureWorksDescription,
  followUpAfterService,
  onCustomerReferenceChange,
  onSoftwareVersionChange,
  onOsVersionChange,
  onWorkDescriptionChange,
  onFutureWorksDescriptionChange,
  onFollowUpAfterServiceChange,
  readOnly
}) => {
  const { t } = useTranslation();

  const handleInsertSafetySentence = () => {
    const safetySentence = t('machineForm.standardSafetySentence');
    if (!workDescription || workDescription.trim() === '') {
      onWorkDescriptionChange(safetySentence);
    } else {
      onWorkDescriptionChange(workDescription + '\n' + safetySentence);
    }
  };

  return (
    <section className="form-section">
      <h3>{t('machineForm.machineInfo')}</h3>
      <div className="form-grid">
        <div className="form-field">
          <label>{t('machineForm.customerReference')}</label>
          <input
            type="text"
            value={customerReference}
            onChange={(e) => onCustomerReferenceChange(e.target.value)}
            disabled={readOnly}
          />
        </div>
        <div className="form-field">
          <label>{t('machineForm.softwareVersion')}</label>
          <input
            type="text"
            value={softwareVersion}
            onChange={(e) => onSoftwareVersionChange(e.target.value)}
            disabled={readOnly}
          />
        </div>
        <div className="form-field">
          <label>{t('machineForm.osVersion')}</label>
          <input
            type="text"
            value={osVersion}
            onChange={(e) => onOsVersionChange(e.target.value)}
            disabled={readOnly}
          />
        </div>
      </div>
      <div className="form-field">
        <label>{t('machineForm.workPerformed')}</label>
        <textarea
          rows={4}
          value={workDescription}
          onChange={(e) => onWorkDescriptionChange(e.target.value)}
          readOnly={readOnly}
        />
        {!readOnly && (
          <div className="field-action-right">
            <button
              type="button"
              onClick={handleInsertSafetySentence}
              className="btn-insert-sentence"
            >
              {t('machineForm.insertSafetySentence')}
            </button>
          </div>
        )}
      </div>
      <div className="form-field">
        <label>{t('machineForm.futureWorks')}</label>
        <textarea
          rows={4}
          value={futureWorksDescription}
          onChange={(e) => onFutureWorksDescriptionChange(e.target.value)}
          readOnly={readOnly}
        />
      </div>
      <div className="form-field">
        <label>{t('machineForm.followUpAfterService')}</label>
        <textarea
          rows={4}
          value={followUpAfterService}
          onChange={(e) => onFollowUpAfterServiceChange(e.target.value)}
          readOnly={readOnly}
        />
      </div>
    </section>
  );
};

export default MachineInfoSection;
